// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import createSvgIcon from '../utils/createSvgIcon';
import React from "react";


export default createSvgIcon(
  <><path d="M2.993 5.500 L 2.640 5.854 5.320 8.533 L 8.000 11.213 10.680 8.533 L 13.360 5.854 13.007 5.500 L 12.654 5.146 10.327 7.473 L 8.000 9.800 5.673 7.473 L 3.346 5.146 2.993 5.500 " stroke="none" fillRule="evenodd" fill="black"></path></>, 
'CaretDown16Icon', {
  viewBox: '0 0 16 16',
  height: '16',
  width: '16',
});